import React from "react";
import "./style.css";

const ButtonPublishAd: React.FC = () => {
  return (
    <button type="button" className="publish-ad-button">
      Publicar anúncio
    </button>
  );
};

export default ButtonPublishAd;
